import { getAuthHeaders } from './authUtils';

const API_ORIGIN = process.env.REACT_APP_API_URL || 'http://localhost:5001';

class PayoutReviewApiService {
  async getReviews({ service = 'payouts', view = 'lines', page = 1, limit = 20, search = '', reason = '' } = {}) {
    const params = new URLSearchParams({
      service,
      view,
      page: String(page),
      limit: String(limit)
    });
    if (search) params.set('search', search);
    if (reason) params.set('reason', reason);

    const response = await fetch(`${API_ORIGIN}/api/payout-reviews?${params.toString()}`, {
      headers: getAuthHeaders()
    });
    if (!response.ok) {
      throw new Error(`Unable to load payout reviews (${response.status})`);
    }
    return response.json();
  }

  async acknowledge(selection) {
    const response = await fetch(`${API_ORIGIN}/api/payout-reviews/acknowledge`, {
      method: 'POST',
      headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
      body: JSON.stringify(selection)
    });
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(body.error || `Unable to close payout reviews (${response.status})`);
    }
    return response.json();
  }
}

export const payoutReviewApi = new PayoutReviewApiService();
